

export const types ={

    // For Authentication
    login: '[Auth] Login',
    logout: '[Auth] Logout',

    // UI
    uiSetError: '[UI] Set Error',
    uiRemoveError: '[UI] Remove Error',
    
    uiStartLoading: '[UI] Start Loading',
    uiFinishLoading: '[UI] Finish Loading',

    //Notes
    notesAddNew: '[Notes] New Note',
    notesActive: '[Notes] Set Active Note',
    notesLoad: '[Notes] Load Notes',
    notesUpdated: '[Notes] Update Note Saved',
    notesFileUrl: '[Notes] Update Image URL',
    notesDelete: '[Notes] Delete Note',
    notesLogoutCleaning: '[Notes] Logout Cleaning'
}